import { NgModule } from "@angular/core";
import { AdminComponent } from "./admin.component";
import { AdminRoutingModule } from "./admin.routing";

@NgModule({
    imports: [AdminRoutingModule],
    declarations: [AdminComponent],
})
export class AdminModule {}
